import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function UserList() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            try {
                const res = await api.get("/users");
                // On s’assure que c’est bien un tableau
                setUsers(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des utilisateurs.");
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // Fonction pour envoyer la demande de reset mot de passe
    const handleResetPassword = async (email) => {
        try {
            alert("Evoi du mail en cours...");
            await api.post("/forgot-password", { email });
            alert("Email de réinitialisation envoyé !");
        } catch (err) {
            console.error(err);

            if (err.response && err.response.status === 400) {
                alert("Trop de demandes. Veuillez réessayer plus tard.");
            } else {
                alert("Erreur lors de l'envoi de l'email de réinitialisation.");
            }
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Utilisateurs</h1>

            <button
                onClick={() => navigate("/add-user")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter un utilisateur
            </button>

            {loading ? (
                <Loading message="Chargement des utilisateurs..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Nom</th>
                                <th className="border px-2 py-1">Email</th>
                                <th className="border px-2 py-1">Réinitialiser le mot de passe</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, index) => {
                                if (user.id !== 1) {
                                    const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                    return (
                                        <tr key={user.id} className={`${bgColor}`}>
                                            <td className="border px-2 py-1">{user.name}</td>
                                            <td className="border px-2 py-1">{user.email}</td>
                                            <td className="border px-2 py-1">
                                                <button
                                                    onClick={() => handleResetPassword(user.email)}
                                                    className="dark:text-blue-300 text-blue-500 text-2xl"
                                                >
                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                }
                                return null; // si user.id === 1, on ne renvoie rien
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
